import { useEffect } from 'react';

import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import Flag from '@atlaskit/flag';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import { token } from '@atlaskit/tokens';

import {
  ComponentFlagId,
  ComponentFlagProps,
  HandleDismissedType,
} from 'src/redux/flags/types';

import { messages } from './online.i18n';

type Props = ComponentFlagProps & {
  id: ComponentFlagId;
  intl: IntlShape;
} & HandleDismissedType;

const OnlineFlag = ({ id, intl, handleDismissed, ...otherProps }: Props) => {
  useEffect(() => {
    const dismissFlag = setTimeout(() => {
      handleDismissed(id);
    }, 2000);

    return () => {
      clearTimeout(dismissFlag);
    };
  }, [id, handleDismissed]);

  return (
    <Flag
      {...otherProps}
      id={id}
      appearance="success"
      icon={
        <CheckCircleIcon
          label="success"
          color={token('color.icon.inverse')}
          spacing="spacious"
        />
      }
      title={intl.formatMessage(messages.onlineTitle)}
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default injectIntl(OnlineFlag);
